/*
 * Lista VIP · Black November — tela de confirmação.
 *
 * Avisa as ferramentas de medição de que houve uma inscrição, uma única vez
 * e só para quem acabou de enviar o formulário (não para quem abriu o link direto).
 * Nenhuma ferramenta é obrigatória: se não estiver na página, nada acontece.
 */
(function () {
  'use strict';

  const DONE_FLAG = 'vip_bn26_inscrita';
  let cameFromForm = false;
  try {
    cameFromForm = sessionStorage.getItem(DONE_FLAG) === '1';
    sessionStorage.removeItem(DONE_FLAG);
  } catch {}
  if (!cameFromForm) return;

  try {
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'Lead', { content_name: 'Lista VIP Black November 2026' });
    }
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'generate_lead', { lista: 'black-november-2026' });
    }
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push({ event: 'lista_vip_confirmada', lista: 'black-november-2026' });
    }
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish('lista_vip_confirmada', { lista: 'black-november-2026' });
    }
  } catch {}
})();
